import React from 'react';
import { Box, Typography } from '@mui/material';
import Reveal from './Reveal';
import { LANDING_FONT, LC, r } from './landingTokens';

// Eyebrow + title + lead, shared across sections. A short accent rule draws in
// above the eyebrow — a consistent "chapter opening" signature per section.
export default function SectionHead({ eyebrow, title, lead, maxWidth, leadMaxWidth, sx }) {
  return (
    <Box sx={{ maxWidth, ...sx }}>
      <Reveal draw repeat delay={60} sx={{ width: r(34), height: r(3), borderRadius: r(2), background: LC.accent, mb: r(14) }} />
      <Box
        sx={{
          fontFamily: LANDING_FONT,
          fontSize: r(12),
          fontWeight: 600,
          letterSpacing: '0.16em',
          textTransform: 'uppercase',
          color: LC.accent,
        }}
      >
        {eyebrow}
      </Box>
      <Typography
        component="h2"
        sx={{
          fontFamily: LANDING_FONT,
          fontSize: 'clamp(1.75rem, 4.4vw, 3rem)',
          fontWeight: 800,
          letterSpacing: '-0.03em',
          lineHeight: 1.04,
          textWrap: 'balance',
          mt: r(14),
          color: LC.ink,
        }}
      >
        {title}
      </Typography>
      {lead && (
        <Typography
          sx={{
            fontFamily: LANDING_FONT,
            fontSize: 'clamp(0.9375rem, 1.9vw, 1.0625rem)',
            color: LC.inkSoft,
            lineHeight: 1.55,
            mt: r(16),
            maxWidth: leadMaxWidth,
          }}
        >
          {lead}
        </Typography>
      )}
    </Box>
  );
}
